// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"LPATutorial__msignaturepad___3MiHQ","m-signature-pad--body":"LPATutorial__m-signature-pad--body___2tNWC","m-signature-pad--footer":"LPATutorial__m-signature-pad--footer___1c-6W","description":"LPATutorial__description___3ARv-","button":"LPATutorial__button___3f3Kg","clear":"LPATutorial__clear___bm7Tv","save":"LPATutorial__save___2LluP","m-signature-pad":"LPATutorial__m-signature-pad___1dRPs","github":"LPATutorial__github___3-UYr","joyrideBtn":"LPATutorial__joyrideBtn___2aG3s"};


//////////////////
// WEBPACK FOOTER
// ./client/app/shared/components/SpotJoyride/LPATutorial.scss
// module id = K8d9
// module chunks = client